import { Table } from 'antd';
import React, { useMemo } from 'react';

import { PostsData } from '../service/posts.interface';
import { AnalyticsFiltersProps } from '../../AnalyticsFilters/service/filters.interface';
import { updateFilters } from '../../../store/analyticFiltersSlice';
import { dynamicPagination } from '../../../../../utils/common/dynamicPagination';
import { getColumns } from '../utils/getColumns';

type Props = {
    readonly source: PostsData;
    readonly filters: AnalyticsFiltersProps;
    readonly onFiltersUpdate: (update: Partial<AnalyticsFiltersProps>) => void;
    readonly loading: boolean;
};

export const PostsTable: React.FC<Props> = ({ source, loading, filters }) => {
    const pagination = useMemo(
        () =>
            dynamicPagination(
                filters,
                updateFilters,
                source?.total_messages,
                'Постов'
            ),
        [filters, updateFilters, source?.total_messages]
    );

    return (
        <Table
            loading={loading}
            dataSource={source?.posts || []}
            rowKey={post => post.post_id}
            pagination={pagination}
            columns={getColumns()}
        />
    );
};
